import styled from 'styled-components';
import {
    GREEN_700,
    GREEN_800,
    GREY_300,
    GREY_400,
    GREY_800,
} from '../../../constants';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

export const Title = styled.h3`
    margin: 0;
    font-size: 1rem;
    font-weight: 600;
    color: ${GREY_800};
`;

export const StatusCard = styled.div<{ $signed?: boolean }>`
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
    padding: 0.75rem 1rem;
    border-radius: 0.5rem;
    background: ${({ $signed }) => ($signed ? 'rgba(84, 194, 121, 0.12)' : 'rgba(0, 0, 0, 0.04)')};
    color: ${({ $signed }) => ($signed ? GREEN_800 : GREY_400)};
`;

export const StatusIcon = styled.span`
    display: flex;
    flex-shrink: 0;
    padding-top: 0.125rem;

    svg {
        width: 1.125rem;
        height: 1.125rem;
    }
`;

export const StatusText = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.125rem;
    min-width: 0;
`;

export const StatusTitle = styled.span`
    font-size: 0.9375rem;
    font-weight: 600;
`;

export const StatusMeta = styled.span<{ $signed?: boolean }>`
    font-size: 0.8125rem;
    color: ${({ $signed }) => ($signed ? GREEN_700 : GREY_300)};
`;

export const Mark = styled.div`
    padding: 0.5rem 0;
`;

export const SignatureImage = styled.img`
    display: block;
    max-width: 100%;
    max-height: 6rem;
`;

export const TypedName = styled.div`
    font-size: 1.375rem;
    font-style: italic;
    color: ${GREY_800};
`;

export const Note = styled.p`
    margin: 0;
    font-size: 0.8125rem;
    line-height: 1.25rem;
    color: ${GREY_300};
`;
